import { variablePatterns } from '../constants/variable-names';
import { PRIMARY_BUTTON_PRESETS_COUNT } from '../constants/button-preset-section-ids';

const expandPrimaryButtonVariables = (variableName) =>
  [...Array(PRIMARY_BUTTON_PRESETS_COUNT)].map((_, number) =>
    variableName.replace(variablePatterns.PRIMARY_BUTTON_VARIABLE, `primary_button_${number + 1}`)
  );

export default expandPrimaryButtonVariables;
